import {Calendar} from "@fullcalendar/core";
import bootstrap5Plugin from "@fullcalendar/bootstrap5";
import dayGridPlugin from "@fullcalendar/daygrid";
import multiMonthPlugin from "@fullcalendar/multimonth";
import listPlugin from "@fullcalendar/list";
import resourceTimelinePlugin from "@fullcalendar/resource-timeline";
import resourceTimeGridPlugin from '@fullcalendar/resource-timegrid';
import plLocale from "@fullcalendar/core/locales/pl";
import timeGridPlugin from "@fullcalendar/timegrid";

window.addEventListener('DOMContentLoaded', event => {
    let calendarEl = document.getElementById('calendar-rooms-holder');
    if (calendarEl) {
        let calendar = new Calendar(calendarEl, {
            dayMaxEventRows: 99,
            dayMaxEvents: false,
            refetchResourcesOnNavigate: true,

            resourceOrder: 'order,type2',
            resources: calendarEl.dataset.resourcesUrl,
            schedulerLicenseKey: 'CC-Attribution-NonCommercial-NoDerivatives',
            height: 'auto',
            themeSystem: 'bootstrap5',
            weekends: false,
            // headerToolbar: {center: 'resourceTimeGridFourDay'},
            plugins: [bootstrap5Plugin, dayGridPlugin, resourceTimeGridPlugin],
            initialView: 'resourceTimeGridFourDay',
            views: {
                resourceTimeGridFourDay: {
                    type: 'resourceTimeGrid',
                    duration: { week: 1 },
                    buttonText: '5 days'
                }
            },
            locale: plLocale,
            slotMinTime: "06:00:00",
            slotMaxTime: "22:00:00",
            nowIndicator: true,

            eventDidMount: function (info) {
                let config = {
                    html: true,
                    title: '<p><strong>' +info.event.extendedProps.person + '</strong><br />' + info.event.extendedProps.startStr +' - '+info.event.extendedProps.endStr +'</p>',
                    placement: 'top',
                    trigger: 'hover',
                    container: 'body'
                };

                let tooltip = new bootstrap.Tooltip(info.el, config);
            },
            events: {
                url: calendarEl.dataset.url,
                method: "POST",
                success: function(data) {
                    // console.log('fetch success');
                    scheduleUpdate();
                },
                failure: function (err) {
                    // console.error('There was an error while fetching events: ' + err.message);
                    scheduleUpdate();
                }
            },
        });

        calendar.render();

        let timeoutId;

        function scheduleUpdate() {
            if(timeoutId !== null) {
                clearTimeout(timeoutId);
            }
            timeoutId = setTimeout(function () {
                calendar.refetchEvents();
            }, 30000);
        }
    }
});